module.exports = __webpack_public_path__ + "img/icon-5.e035f210.svg";